/* AVRA fix layer — ported from the 2026-08-31 tastemaker audit.
   Behaviour-only fixes. Styling lives in assets/avra-fixes.css.
   Loaded with `defer` at the end of layout/theme.liquid.

   APPLIED HERE: FIX 8 (accordion photo), FIX 9 (hero alt text),
   FIX 14c (the wipe) and FIX 14d (bag-count landing).
   FIX 14c's Escape handling lives in assets/avra-escape.js.
   FIX 2 (promo strip wording) was not requested and is not included.

   Delete this file + its <script> tag and the theme returns to its
   previous behaviour exactly. */

(function () {
  'use strict';

  /* ── FIX 9 (MINOR) ────────────────────────────────────────
     The hero photos ship with alt="". They are the brand's main imagery,
     not decoration, so Google and screen readers get nothing. Matched by
     filename against what those photos actually show. Add more pairs as
     you add imagery — first match wins, and any img that already has an
     alt is left alone.

     2026-09-10: keyed to the photos THIS theme actually uses. The main
     hero panel is IMG-7805 and the side panel IMG-7837; IMG-7303 is the
     Necklaces category tile and IMG-7806 the AVRA Standard photo.
     ───────────────────────────────────────────────────── */

  var ALT = [
    ['IMG-7805', 'AVRA model wearing a 14k gold diamond necklace, photographed in natural light.'],
    ['IMG-7837', 'AVRA model wearing diamond drop earrings and stacked 14k gold rings.'],
    ['IMG-7303', 'Two AVRA diamond necklaces layered at the neck — an emerald-cut pendant above a pear-cut drop, both in 14k gold.'],
    ['IMG-7806', 'An AVRA piece being finished by hand on the bench in Miami.'],
    ['IMG-7798', 'AVRA model wearing a 14k gold diamond necklace, photographed in natural light.']
  ];

  function fixAlt() {
    document.querySelectorAll('img').forEach(function (img) {
      if (img.alt) return;
      var src = img.getAttribute('src') || '';
      for (var i = 0; i < ALT.length; i++) {
        if (src.indexOf(ALT[i][0]) > -1) { img.alt = ALT[i][1]; return; }
      }
    });
  }

  /* ── FIX 8 (MAJOR) ────────────────────────────────────────
     "THE AVRA STANDARD" is six rows of prose beside ONE photo that never
     changes. The claims — solid 14k, VS/VVS, hand-finished in Miami — are
     argued in sentences instead of shown. This wires the mechanism: open a
     row, the photo changes.

     The Diamonds row now has its own photograph: five loose stones, one in
     the tweezers. The other five rows fall back to the section's own image
     until there is a photograph worth showing for each. Put a URL against
     a row id below and that row starts doing work. The ids on this theme
     are, exactly:
       ps-materials · ps-craft · ps-diamonds · ps-last · ps-ethical · ps-promise
     ───────────────────────────────────────────────────── */

  var ROW_PHOTO = {
    'ps-diamonds': 'https://cdn.shopify.com/s/files/1/0788/1572/3577/files/image.jpg?v=1789002344&width=1100'
    // 'ps-materials': '…/14k-stamp-macro.jpg',
    // 'ps-craft':     '…/bench-hands.jpg',
    // 'ps-promise':   '…/cloth-and-box.jpg'
  };

  function wireAccordionPhoto() {
    var img = document.querySelector('.promise__media img');
    if (!img) return;

    var original = img.getAttribute('src');
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

    /* Decode the incoming photo before swapping, so the fade never lands
       on a blank frame the first time a row is opened. */
    Object.keys(ROW_PHOTO).forEach(function (k) {
      var pre = new Image();
      pre.src = ROW_PHOTO[k];
    });

    function swap(src) {
      img.src = src;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.style.opacity = '1';
    }

    function show(src) {
      if (img.getAttribute('src') === src) return;
      if (calm && calm.matches) { img.style.transition = 'none'; swap(src); return; }
      img.style.transition = 'opacity .28s cubic-bezier(.22,.61,.36,1)';
      img.style.opacity = '0';
      setTimeout(function () { swap(src); }, 200);
    }

    /* We watch the ROW's `open` class, not the button's aria-expanded.
       SEPARATE BUG FOUND WHILE BUILDING THIS: the theme opens the panel but
       never updates aria-expanded — it stays "false" on an open row, so a
       screen reader always announces the section as collapsed. That one has
       to be fixed in the theme's accordion JS, not here. */
    var rows = document.querySelectorAll('.promise__row');
    if (!rows.length) return;

    /* Several rows can be open at once, so "which photo" means the row the
       visitor opened MOST RECENTLY. That is an ordered stack, not a set:
       with a set, closing Diamonds left the diamond photo on screen even
       though only Materials was still open. The stack lets a close fall
       back to whatever is still open underneath it. */
    var openStack = [];
    rows.forEach(function (r) { if (r.classList.contains('open')) openStack.push(r); });

    function photoFor(row) {
      var btn = row && row.querySelector('.promise__sum');
      return (btn && ROW_PHOTO[btn.id]) || null;
    }

    /* Newest open row that has a photo of its own wins; if none of the open
       rows has one, fall back to the section's own image. */
    function paint() {
      for (var i = openStack.length - 1; i >= 0; i--) {
        var p = photoFor(openStack[i]);
        if (p) { show(p); return; }
      }
      show(original);
    }

    var observer = new MutationObserver(function (records) {
      var changed = false;
      for (var i = 0; i < records.length; i++) {
        var row = records[i].target;
        var isOpen = row.classList.contains('open');
        var at = openStack.indexOf(row);
        if (isOpen && at === -1) { openStack.push(row); changed = true; }
        else if (!isOpen && at > -1) { openStack.splice(at, 1); changed = true; }
      }
      if (changed) paint();
    });

    rows.forEach(function (row) {
      observer.observe(row, { attributes: true, attributeFilter: ['class'] });
    });
  }

  /* ── FIX 14d ─────────────────────────────────────────────
     Give the bag count a landing. Watches its text and pops it once.
     ───────────────────────────────────────────────────── */

  function wireCartLanding() {
    var n = document.querySelector('.cart-n');
    if (!n || !window.MutationObserver) return;

    var last = n.textContent;
    new MutationObserver(function () {
      if (n.textContent === last) return;
      last = n.textContent;
      n.classList.remove('avra-cart-land');
      void n.offsetWidth;               /* restart the animation */
      n.classList.add('avra-cart-land');
    }).observe(n, { childList: true, characterData: true, subtree: true });

    /* animationend is the normal path, but it never fires while the tab is
       hidden (frames are throttled). Without a fallback the class sticks. */
    var clear = function () { n.classList.remove('avra-cart-land'); };
    n.addEventListener('animationend', clear);
    n.addEventListener('animationcancel', clear);
    setInterval(function () {
      if (n.classList.contains('avra-cart-land') && document.hidden) clear();
    }, 1000);
  }

  /* ── FIX 14c, the wipe ──────────────────────────────────────
     clip-path reveal on the two editorial photos. Once each, never again.
     ───────────────────────────────────────────────────── */

  function wireWipe() {
    var targets = document.querySelectorAll('.about__media, .promise__media');
    if (!targets.length) return;

    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (calm && calm.matches) return;   /* leave the photos plainly visible */

    if (!('IntersectionObserver' in window)) return;

    /* TRAP, found the hard way: clip-path shrinks the element's intersection
       rect to nothing, so observing the clipped element itself reports
       isIntersecting:false forever and the photo never un-clips. Observe the
       UNCLIPPED parent instead. */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var media = en.target.querySelector('.about__media, .promise__media');
        if (media) media.classList.add('avra-wiped');
        io.unobserve(en.target);
      });
    }, { threshold: 0.15 });

    targets.forEach(function (t) {
      t.classList.add('avra-wipe');
      var parent = t.parentElement;
      if (parent) io.observe(parent);

      /* Fail-safe: a decorative reveal must never be the reason a photo
         stays hidden. If nothing has un-clipped it within 3s, show it. */
      setTimeout(function () { t.classList.add('avra-wiped'); }, 3000);
    });
  }

  function run() {
    fixAlt();
    wireAccordionPhoto();
    wireCartLanding();
    wireWipe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
